import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';
import { AuthProvider, useAuth } from './context/AuthContext';
import Dashboard from './components/Dashboard/Dashboard';
import ManageSlotsPage from './ManageSlotsPage';
import ManageAppointmentsPage from './ManageAppointmentsPage';
import MessageTemplatesPage from './components/Settings/MessageTemplatesPage';
import AppointmentMessageVariantsPage from './components/Settings/AppointmentMessageVariantsPage';
import Login from './components/Auth/Login';
import PublicBookingPage from './components/PublicBookingPage';

// Configure Amplify
Amplify.configure(awsExports);

// PrivateRoute component to protect routes
const PrivateRoute = ({ children }) => {
  const { currentUser } = useAuth();
  
  if (!currentUser) {
    return <Navigate to="/login" />;
  }
  
  return children;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route 
            path="/" 
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/manage-slots" 
            element={
              <PrivateRoute>
                <ManageSlotsPage />
              </PrivateRoute>
            } 
          />    
          <Route 
            path="/manage-appointments" 
            element={
              <PrivateRoute>
                <ManageAppointmentsPage />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/message-templates" 
            element={
              <PrivateRoute>
                <MessageTemplatesPage />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/appointment-message-variants" 
            element={
              <PrivateRoute>
                <AppointmentMessageVariantsPage />
              </PrivateRoute>
            } 
          />                  
          <Route path="/public-booking" element={<PublicBookingPage />} /> {/* ✅ Public route */}       
          <Route path="*" element={<Navigate to="/" />} />          
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;